import React, { useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";

enum ContextMenuOperation {
  Separator,
  CopyCell,
  PasteCell,
}

export class ContextMenuOption {
  constructor(
    readonly operation: ContextMenuOperation,
    readonly text: string,
  ) {}
}

export const AvailableOptions = {
  separator: new ContextMenuOption(ContextMenuOperation.Separator, ""),
  copyCell: new ContextMenuOption(ContextMenuOperation.CopyCell, "Copy Cell"),
  pasteCell: new ContextMenuOption(
    ContextMenuOperation.PasteCell,
    "Paste Cell",
  ),
};

interface ModelInfoContextMenuProps {
  onClose: () => void;
  onCopyCell: () => void;
  onPasteCell: () => void;
  options: ContextMenuOption[];
  style?: React.CSSProperties;
}

const ContextMenuEngine: React.FC<ModelInfoContextMenuProps> = ({
  onClose,
  onCopyCell,
  onPasteCell,
  options,
  style,
}) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !event.target ||
        !(event.target as HTMLElement).closest(".context-menu")
      ) {
        onClose();
      }
    };

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClose]);

  const handleOptionSelect = (operation: ContextMenuOperation) => {
    switch (operation) {
      case ContextMenuOperation.CopyCell:
        onCopyCell();
        break;
      case ContextMenuOperation.PasteCell:
        onPasteCell();
        break;
      default:
        return;
    }

    // close if it was handled
    onClose();
  };

  return (
    <ButtonGroup vertical style={style} className="context-menu">
      {options.map((option, key) =>
        option.operation !== ContextMenuOperation.Separator ? (
          <Button
            key={key}
            variant="secondary"
            onClick={(e) => {
              handleOptionSelect(option.operation);
              e.stopPropagation();
            }}
          >
            {option.text}
          </Button>
        ) : (
          <div
            key={key}
            style={{ padding: "1px", backgroundColor: "white", width: "100%" }}
          />
        ),
      )}
    </ButtonGroup>
  );
};

export default ContextMenuEngine;
